import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery } from '@tanstack/react-query';
import EnhancedTable, { HeadCell } from '../../common/components/EnhancedTable';
import { customtheme } from '../../app/theme/theme';
import { getQuotes } from '../../app/services/quotes/get-quotes.api';
import QuotesConsultDrawer from './QuotesConsultDrawer';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: customtheme.gray[200],
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  topBar: {
    backgroundColor: customtheme.gray[200],
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableSection: {
    padding: theme.spacing(4),
    flex: 1,
    display: 'flex',
  },
  tableSectionContainer: {
    padding: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
  },
}));

const QuotesConsult = () => {
  const classes = useStyles();

  const windowHeight = window.innerHeight;
  const headerHeight = 500;
  const footerHeight = 48;
  const itemHeight = 80;
  const availableHeight = windowHeight - headerHeight - footerHeight;
  const itemsPerPage = Math.floor((availableHeight) / itemHeight);

  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerRecord, setDrawerRecord] = useState<any | null>(null);
  const [orderBy, setOrderBy] = useState<string>('numcot');
  const [selected, setSelected] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPage > 10 ? itemsPerPage : 10);

  const { isFetching, refetch } = useQuery(['quotesConsult', page, rowsPerPage], async () => {
    const token = localStorage.getItem('token');
    if (token) {
      const res = await getQuotes(token, { take: rowsPerPage, skip: page * rowsPerPage });
      if (res) {
        setSelectedData(res.results.map((r: any) => ({ ...r, item: [r] })));
        setCount(res.total ?? res.count ?? 0);
      }
    }
    return [];
  }, { refetchOnWindowFocus: false });

  useEffect(() => {
    refetch();
  }, [page, rowsPerPage, refetch]);

  const headCells: HeadCell[] = [
    { id: 'numcot', numeric: true, disablePadding: false, label: 'Nº Cotação' },
    { id: 'apefor', numeric: false, disablePadding: true, label: 'Fornecedor' },
    { id: 'nomemp', numeric: false, disablePadding: true, label: 'Empresa' },
    { id: 'datcot', numeric: false, disablePadding: true, label: 'Data Cotação' },
    { id: 'vlrcot', numeric: true, disablePadding: false, label: 'Valor' },
    { id: 'numsol', numeric: true, disablePadding: false, label: 'Nº Solicitação' },
    { id: 'actions', numeric: true, disablePadding: false, label: 'Ações' },
  ];

  const createData = (props: any, index: number) => {
    const id = `${props.numcot ?? ''}-${props.numsol ?? ''}`;
    const numcot = props.cotacao?.numcot ?? props.numcot ?? '';
    const apefor = props.cotacao?.apefor ?? props.apefor ?? '';
    const nomemp = props.cotacao?.nomemp ?? props.nomemp ?? '';
    const datcot = props.cotacao?.datcot ?? props.datcot ?? '';
    const vlrcot = props.cotacao?.vlrcot ?? props.vlrcot ?? props.cotacao?.vlrcot ?? '';
    const numsol = props.solicitacao.numsol ?? props.numsol ?? '';
    return { id, numcot, apefor, nomemp, datcot, vlrcot, numsol, ...props };
  };

  const handleInfo = (id: string) => {
    console.log(selectedData);
    const item = selectedData.find((d: any) => `${d.id}` === id);
    if (item) {
      setDrawerRecord(item);
      setDrawerOpen(true);
    }
  };

  return (
    <div className={classes.root}>
      <div style={{ padding: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Cotações</Typography>
      </div>
      <div className={classes.tableSection}>
        <Container className={classes.tableSectionContainer}>
          <EnhancedTable
            title=""
            rowsPerPageOptions={[]}
            isClickable={false}
            data={selectedData?.map((data: any, idx: number) => createData(data, idx))}
            count={count}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            headCells={headCells}
            isLoading={isFetching}
            selected={selected}
            setSelected={setSelected}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            buttonsSelected={[]}
            buttonsActions={['info']}
            handleInfo={handleInfo}
          />
        </Container>
      </div>

      <QuotesConsultDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} record={drawerRecord} />
    </div>
  );
};

export default QuotesConsult;
